import { trpc } from '@web/lib/trpc';

import { BrandDetailsCard } from './brand-details-card';

export function BrandDetailsView({
  brandId,
  onClose,
}: {
  brandId: string;
  onClose: () => void;
}) {
  const { data: brandDetailsData } = trpc.brand.getDetails.useQuery({
    id: brandId,
  });

  const { mutateAsync: updateBrandMutation } = trpc.brand.edit.useMutation();


  if (!brandDetailsData) return null;

  return (
    <BrandDetailsCard
      brand={brandDetailsData}
      onSubmit={async (brandData) => {
        await updateBrandMutation(brandData);
      }}
      onClose={onClose}
    />
  );
}
